<template>
  <span v-if="node.type === AUDIT_VALUE_NULL" class="text-muted">-</span>
  <span v-else-if="node.type === AUDIT_VALUE_BOOLEAN">
    <i :class="['fa', node.booleanValue ? 'fa-check text-success' : 'fa-times text-danger']" />
  </span>
  <span v-else-if="node.type === AUDIT_VALUE_SCALAR">{{ node.scalarValue }}</span>
  <ul v-else-if="node.type === AUDIT_VALUE_LIST" class="mb-0 ps-3">
    <li v-for="(item, index) in node.listItems" :key="index">
      <AuditValue :value="item" />
    </li>
  </ul>
  <div v-else-if="node.type === AUDIT_VALUE_OBJECT" class="small">
    <ul class="mb-0 ps-3">
      <li v-for="entry in node.objectEntries" :key="entry.key">
        <b>{{ entry.label }}:</b>
        <AuditValue :value="entry.value" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import type { AuditValueNode } from '@/types/Models/AuditLog'
import type { ComputedRef } from 'vue'
import { computed, defineComponent } from 'vue'
import { resolveValueNode } from '@/composables/AuditLog/useAuditLogDetails'
import {
  AUDIT_VALUE_BOOLEAN,
  AUDIT_VALUE_LIST,
  AUDIT_VALUE_NULL,
  AUDIT_VALUE_OBJECT,
  AUDIT_VALUE_SCALAR,
} from '@/const/AuditValueTypes'

export default defineComponent({
  name: 'AuditValue',
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: null,
    },
  },
  setup(props) {
    const node: ComputedRef<AuditValueNode> = computed(() => resolveValueNode(props.value))

    return {
      node,
      AUDIT_VALUE_NULL,
      AUDIT_VALUE_BOOLEAN,
      AUDIT_VALUE_SCALAR,
      AUDIT_VALUE_LIST,
      AUDIT_VALUE_OBJECT,
    }
  },
})
</script>

